import React from "react";

import asIcon from "./asIcon";

export default asIcon(
  ({ color }) =>
    <path fill={color} d="M74 42.5H57.5V26h-15v16.5H26v15h16.5V74h15V57.5H74z" />,
);
